import './App.css';
import { Route, Routes, Navigate } from 'react-router-dom';
import Header from './Header.js';
import Footer from './Footer.js';
import { useState } from 'react';



// Pages imports
import Home from './pages/Home-page.js';
import AboutUspage from './pages/About-us-page.js';
import ContactPage from './pages/Contact-page.js';
import CommercialPage from './pages/Commercial-page.js';
import FactsPage from './pages/Facts-page.js';
import IndusterialPage from './pages/Industerial.js';
import MoldRemediationPage from './pages/Mold-Remediation-page.js';


const App = () => {
  
  return (
    <>
      <Header  />
      
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/contact-us" element={<ContactPage />} />
        <Route path="/about-us" element={<AboutUspage />} />
        <Route path="/commercial" element={<CommercialPage />} />
         <Route path="/mold-inspections" element={<FactsPage />} />
         <Route path="/industerial-building" element={<IndusterialPage />} />
         <Route path="/mold-remediation" element={<MoldRemediationPage />} />
        
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
     
      <Footer />
    </>
  );
};

export default App;
